import Logo from "./Logo";
export default Logo;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Logo/index.tsx